module.exports = "<div class=\"image-container\">\r\n  <img [src]=\"image | blobToImage:columnDef:extension\"/>\r\n</div>\r\n"